import { Koi } from '@ksyos/koi';
import { getTextInputStringSchema } from '@common/validation/utils/getTextInputStringSchema';

export type HolterReadOutDraftData = {
    downloadedDatetime: string | Date | null;
    downloadProgress: number | string | null;
    ecgStorageName: string | null;
    edfMetadata: {
        durationSeconds: number;
        endDatetime: string;
        startDatetime: string;
    }[];
    holterStartedDatetime: string | Date | null;
    uploadProgress: number | null;
};

export const holterReadOutDraftSchema = Koi.object({
    downloadProgress: Koi.alternatives(Koi.number().min(0).max(100), Koi.numberAsString()).allow(null),
    downloadedDatetime: getTextInputStringSchema(true),
    ecgStorageName: getTextInputStringSchema(true),
    edfMetadata: Koi.array().items(
        Koi.object({
            durationSeconds: Koi.number(),
            endDatetime: getTextInputStringSchema(),
            startDatetime: getTextInputStringSchema(),
        })
    ),
    holterStartedDatetime: getTextInputStringSchema(true),
    uploadProgress: Koi.number().min(0).max(100).allow(null),
});
export const holterReadOutFinalSchema = Koi.object({
    downloadProgress: Koi.alternatives(Koi.number().min(0).max(100), Koi.numberAsString()),
    downloadedDatetime: getTextInputStringSchema(),
    ecgStorageName: getTextInputStringSchema(true),
    edfMetadata: Koi.array().items(
        Koi.object({
            durationSeconds: Koi.number(),
            endDatetime: getTextInputStringSchema(),
            startDatetime: getTextInputStringSchema(),
        })
    ),
    holterStartedDatetime: getTextInputStringSchema(),
    uploadProgress: Koi.number().min(0).max(100),
});

export const initialHolterReadOutData: HolterReadOutDraftData = {
    downloadProgress: null,
    downloadedDatetime: null,
    ecgStorageName: null,
    edfMetadata: [],
    holterStartedDatetime: null,
    uploadProgress: null,
};

export type HolterReadOutReadData = {
    dateUploadedToAnalysisParty?: string;
};

export const cardioHolterReadOutSections = [
    {
        items: [{ key: 'dateUploadedToAnalysisParty', label: 'Datum geupload naar analysepartij' }],
    },
];
